module.exports = __webpack_public_path__ + "static/media/5@3x.4ec29afa.png";